import AuthorityBuilder from 'pojos/AuthorityBuilder.js'

const Reports = new AuthorityBuilder({
	accessGroup: 'REPORTS',
	accessType: ['ACCESS']
})

const ReportsBillingByProduct = new AuthorityBuilder({
	accessGroup: 'REPORTS_BILLING_BY_PRODUCT',
	accessType: ['ACCESS', 'LIST_READ', 'LIST_EXPORT_READ']
})

const ReportsBillingByCategory = new AuthorityBuilder({
	accessGroup: 'REPORTS_BILLING_BY_CATEGORY',
	accessType: ['ACCESS', 'LIST_READ', 'LIST_EXPORT_READ']
})

export default [
	Reports,
	ReportsBillingByProduct,
	ReportsBillingByCategory
]
